(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
var wrappers = document.querySelectorAll('.hero__media-wrapper--sequential');
wrappers.forEach(function (wrapper) {
var altData = wrapper.getAttribute('data-hero-alt-images');
if (altData) {
var urls = altData.split('|').map(function (s) { return s.trim(); }).filter(Boolean);
if (urls.length > 1) {
var pick = urls[Math.floor(Math.random() * urls.length)];
var img = wrapper.querySelector('img');
if (img) {
img.removeAttribute('srcset');
img.src = pick;
}
}
}
var video = wrapper.querySelector('video');
if (video) {
video.loop = false;
video.addEventListener('ended', function () {
var hero = wrapper.closest('.hero');
if (hero) {
hero.classList.add('hero--sequential-done');
}
});
}
});
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
